export const MISNAP_CAPTURE_OPTIONS = {
  qualityPercent: 90,
  hintFrequencyMS: 3000,
  hintAriaLive: 1, // (0=off / 1=polite / 2=assertive)
  guidePaddingLevel: 1, // (1=large, 2=medium, 3=small)
  hintMessageSize: 2, // (1=small / 2=medium / 3=large)
  disableMirroring: false, // mirroring of live-preview for Selfie
  disablePerpendicularCapture: false, // require the orientation of the document to match the orientation of the device during capture
  disableSmileDetection: false, // smile detection for Selfie
  faceDetectionLevel: 1, // (1=lenient, 2=moderate, 3=strict)
  videoRecordingEnabled: false,
  audioRecordingEnabled: false,
  videoQuality: 70, // only applies if videoRecordingEnabled = true
  videoRecordingMessage: 'Recording',
};
